(() => {
  if (window.cartRebuySliderReady) return;
  window.cartRebuySliderReady = true;

  const ARROW = {
    prev: '<svg viewBox="0 0 8 14" aria-hidden="true"><path d="M7 1 1 7l6 6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    next: '<svg viewBox="0 0 8 14" aria-hidden="true"><path d="m1 1 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>'
  };

  const updateArrows = (grid, arrows) => {
    const [prev, next] = arrows.querySelectorAll('button');
    const maxScroll = grid.scrollWidth - grid.clientWidth - 1;
    prev.disabled = grid.scrollLeft <= 0;
    next.disabled = grid.scrollLeft >= maxScroll;
    arrows.hidden = maxScroll <= 0;
  };

  const enhance = (widget) => {
    const content = widget.querySelector('.rebuy-widget-content');
    const grid = widget.querySelector('.rebuy-product-grid');
    if (!content || !grid || content.querySelector('.rebuy-slider-arrows')) return;

    const arrows = document.createElement('div');
    arrows.className = 'rebuy-slider-arrows';
    ['prev', 'next'].forEach((direction) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rebuy-slider-arrow';
      button.setAttribute('aria-label', direction === 'prev' ? 'Previous products' : 'Next products');
      button.innerHTML = ARROW[direction];
      button.addEventListener('click', () => {
        const card = grid.querySelector('.rebuy-product-block');
        const step = card ? card.getBoundingClientRect().width + 12 : grid.clientWidth * 0.8;
        grid.scrollBy({ left: direction === 'prev' ? -step : step });
      });
      arrows.append(button);
    });
    content.append(arrows);

    grid.addEventListener('scroll', () => updateArrows(grid, arrows), { passive: true });
    requestAnimationFrame(() => updateArrows(grid, arrows));
  };

  const SAMPLE_SIZE = '2 oz. Pouch';
  const metaCache = new Map();

  const loadMeta = (handle) => {
    if (!metaCache.has(handle)) {
      metaCache.set(
        handle,
        fetch(`/products/${handle}?section_id=cart-card-meta`)
          .then((response) => (response.ok ? response.text() : ''))
          .then((html) => {
            const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-card-meta]');
            return { notes: node?.dataset.notes || '', size: node?.dataset.size || '' };
          })
          .catch(() => ({ notes: '', size: '' }))
      );
    }
    return metaCache.get(handle);
  };

  const addLine = (info, after, className, text) => {
    if (!text || info.querySelector(`.${className}`)) return after;
    const line = document.createElement('p');
    line.className = className;
    line.textContent = text;
    after.after(line);
    return line;
  };

  const enhanceCard = async (block) => {
    if (block.dataset.cardEnhanced) return;
    block.dataset.cardEnhanced = 'true';

    const link = block.querySelector('.rebuy-product-title-link');
    const title = block.querySelector('.rebuy-product-title');
    const info = block.querySelector('.rebuy-product-info');
    if (!link || !title || !info) return;

    const fullTitle = link.textContent.trim();
    if (!/pouch/i.test(fullTitle)) return;

    const isSample = /sample pouch/i.test(fullTitle);
    link.textContent = fullTitle.replace(/\s*(2\s*oz\.?\s*)?sample pouch\s*$/i, '').trim() || fullTitle;

    const handle = new URL(link.href, window.location.origin).pathname.split('/products/')[1]?.split('/')[0];
    if (!handle) return;

    const meta = await loadMeta(handle);
    const notesLine = addLine(info, title, 'rebuy-card-notes', meta.notes);
    addLine(info, notesLine, 'rebuy-card-size', meta.size || (isSample ? SAMPLE_SIZE : ''));
  };

  let scanQueued = false;
  const scan = () => {
    scanQueued = false;
    document.querySelectorAll('cart-drawer .rebuy-widget').forEach(enhance);
    document.querySelectorAll('cart-drawer .rebuy-product-block').forEach(enhanceCard);
  };
  const queueScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(scan);
  };

  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
